import { useState } from "react";
import { toast } from "sonner";
import { Copy, Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { copyText } from "../lib/api";

export const InvitePasswordField = ({ form, set }) => {
  const [show, setShow] = useState(false);
  const tooShort = form.password_enabled && form.invite_password.trim().length < 4;
  const copy = async () => {
    await copyText(form.invite_password);
    toast.success("Password copied");
  };
  return (
    <div className="space-y-4">
      <label htmlFor="password-toggle" className="flex cursor-pointer items-center justify-between gap-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
        <span>
          <span className="block text-sm font-semibold text-slate-900">Password protect this invitation</span>
          <span className="block text-xs text-slate-500">Guests must enter the password before they see anything.</span>
        </span>
        <Switch id="password-toggle" data-testid="event-password-toggle" checked={form.password_enabled} onCheckedChange={set("password_enabled")} />
      </label>
      {form.password_enabled && (
        <div className="space-y-1.5">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Input
                data-testid="event-password-input"
                type={show ? "text" : "password"}
                autoComplete="off"
                maxLength={64}
                value={form.invite_password}
                onChange={(e) => set("invite_password")(e.target.value)}
                placeholder="At least 4 characters"
                className="h-12 rounded-xl pr-11"
              />
              <button type="button" data-testid="event-password-show-btn" onClick={() => setShow((v) => !v)} aria-label={show ? "Hide password" : "Show password"} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700">
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
            <button type="button" data-testid="event-password-copy-btn" onClick={copy} disabled={!form.invite_password} className="inline-flex h-12 items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50">
              <Copy className="h-4 w-4" /> Copy
            </button>
          </div>
          {tooShort && <p data-testid="event-password-error" className="text-xs font-semibold text-red-600">Password must be at least 4 characters</p>}
          <p className="text-xs text-slate-500">Changing the password signs out guests who already unlocked the invite.</p>
        </div>
      )}
    </div>
  );
};
